import React from 'react'
import { useState } from 'react'
import { uploadFile } from '../Firebase/MainFirebase'
import VisitorCounter from '../Comp/VisitorCounter'

const Upload = () => {
    const [image, setImage] = useState(null)
    console.log(image)
    const clkBtn = () => {
        uploadFile(image.name, image)
            .then((succ) => {
                console.log(succ)
            })
            .catch((err) => {
                console.log(err)
            })

    }

    return (
        <div>
            <input type="file" name="" id="" onChange={(e) => setImage(e.target.files[0])} />
            <button onClick={clkBtn}>upload</button>
        </div>
    )
}

export default Upload
